import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { AlertError } from './Alert';

const sample: Dictionary<{ down: string }> = {
  pl: { down: 'AI Dude jest chwilowo niedostępny. Spróbuj za kilka minut.' },
  en: { down: 'AI Dude is unavailable right now. Try again in a few minutes.' },
};

export default {
  kind: 'component',
  title: { pl: 'Alert', en: 'Alert' },
  description: {
    pl: 'Błąd w treści strony, gdy porażka *jest* tą treścią. Wynik żądania (zapisano, nie udało się) to toast, nie alert.',
    en: 'An inline failure, for when the failure *is* the page content. The result of a request (saved, failed) is a toast, not an alert.',
  },
  variants: [
    {
      name: { pl: 'Błąd', en: 'Error' },
      render: (locale) => <AlertError message={sample[locale].down} />,
    },
  ],
} satisfies Story;
